module.exports = __webpack_public_path__ + "img/miniprogram-qr.83f6efee.png";